import { render, staticRenderFns } from "./AddGoods.vue?vue&type=template&id=7e719786&scoped=true"
import script from "./AddGoods.vue?vue&type=script&lang=js"
export * from "./AddGoods.vue?vue&type=script&lang=js"
import style0 from "./AddGoods.vue?vue&type=style&index=0&id=7e719786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e719786",
  null
  
)

export default component.exports